module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bKyGr"))).then(() => parcelRequire('cvs7o'));